import { render } from "./operat.vue?vue&type=template&id=87aeb0c6&scoped=true&ts=true"
import script from "./operat.vue?vue&type=script&lang=ts"
export * from "./operat.vue?vue&type=script&lang=ts"

import "./operat.vue?vue&type=style&index=0&id=87aeb0c6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87aeb0c6"]])

export default __exports__